export const PROCUREMENT_CHILD_ROUTES = [
  '/supply-chain/requisitions',
  '/supply-chain/purchase-orders',
  '/supply-chain/approval-inbox',
  '/supply-chain/vendors',
];

/** Flat flyout links for Procurement under Administration (single row › panel). */
export function buildProcurementFlyoutItems(hasMenuAccess) {
  return [
    hasMenuAccess('/supply-chain/requisitions') ? { label: 'Requisitions', path: '/supply-chain/requisitions' } : null,
    hasMenuAccess('/supply-chain/purchase-orders')
      ? { label: 'Purchase Orders', path: '/supply-chain/purchase-orders' }
      : null,
    (hasMenuAccess('/supply-chain/approval-inbox') || hasMenuAccess('/supply-chain/requisitions'))
      ? { label: 'Approval Inbox', path: '/supply-chain/approval-inbox' }
      : null,
    hasMenuAccess('/supply-chain/vendors') ? { label: 'Vendors / Suppliers', path: '/supply-chain/vendors' } : null,
  ].filter(Boolean);
}
